import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { defineMessages, injectIntl } from 'react-intl'
import { forceHistory, scrollToAnchorOnMount } from '../../../../composables'
import { setDocumentTitle } from '../../../../helpers/browser'
import { selectHomeNotFound } from '../../../../store/selectors/home'
import { selectLatestMortgageRates } from '../../../../store/selectors/mortgageRate'

const DIGEST_META = defineMessages({
  title: {
    id: 'Homeowners.document.title',
    defaultMessage: 'Homebot for homeowners'
  }
})

const DigestContainer = compose(
  connect(state => ({
    latestRates: selectLatestMortgageRates(state),
    notFound: selectHomeNotFound(state)
  })),
  injectIntl,
  forceHistory,
  lifecycle({
    componentDidMount() {
      const { intl } = this.props

      setDocumentTitle(intl.formatMessage(DIGEST_META.title))
    }
  }),
  scrollToAnchorOnMount
)

export default DigestContainer
